import { render, staticRenderFns } from "./autosize-textarea.vue?vue&type=template&id=a7cb2808&"
import script from "./autosize-textarea.vue?vue&type=script&lang=js&"
export * from "./autosize-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7cb2808')) {
      api.createRecord('a7cb2808', component.options)
    } else {
      api.reload('a7cb2808', component.options)
    }
    module.hot.accept("./autosize-textarea.vue?vue&type=template&id=a7cb2808&", function () {
      api.rerender('a7cb2808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/autosize-textarea.vue"
export default component.exports